import React, { Fragment, useState, useEffect } from "react";
import "./styles.css";

import { ReactComponent as TickIcon } from "common/assets/svg/tickIconOffer.svg";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { usePlaceOrder } from "hooks/usePlaceOrder";

import { useSpring, useTransition, animated } from "react-spring";
import {  useParams, useLocation } from "react-router";
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import { useMemo } from "react";
import { dialogOpen } from "common/features/navigation/navigationActions";

interface ConfirmationPromptProps {
  question: string;
  isOpen: boolean;
  submitPrompt: any;
  InfoImage: any;
  visible: any;
  // setIsOpen: any;
}

function SurveyPrompt(props: any) {
  const {
    isOpen,
    visible,
    // setIsOpen,
  } = props;
const dispatch = useDispatch()
const modal_open = useSelector(
  (state: RootState) => state.navigation.modal_open
);

  const [
    makeOrder,
    totalItemsubTotal,
    totalOrderPrice,
    totalTaxAndCharges,
    totalItemTaxAmount,
    tipAmount,
    packagingCharge,
    discountAmount,
  ] = usePlaceOrder();

  const history = useHistory();

  // useEffect(() => {
  //   const unlisten = history.listen(() => {
  //     dispatch(dialogOpen(false))
  //   });
  //   return () => unlisten();
  // }, [history]);


  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      // console.log({location,action});
      
      if (action === 'POP' && modal_open ) {
        history.go(1)
        dispatch(dialogOpen(false))
      }
      if(action === 'PUSH' && !modal_open){
        history.go(1)
      }
    });

    // Cleanup function to remove the event listener
    return () => unlisten();
  }, []);


  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: modal_open ? 1 : 0 },
  });

  const transitions = useTransition(modal_open, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  const selectedOffer = useSelector(
    (state: RootState) => state.offer.selectedOffer
  );
  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const offerAmount = useMemo(() => {
    if (selectedOffer && selectedOffer.offerType == "PERCENT") {
      let discount = (selectedOffer.offerRate / 100) * totalItemsubTotal;
      return discount > selectedOffer.maxDiscount
        ? selectedOffer.maxDiscount
        : discount;
    } else if (selectedOffer && selectedOffer.offerType == "FLATFEE") {
      return selectedOffer?.maxDiscount;
    } else {
      return 0;
    }
  }, [selectedOffer]);

  return (
    <Fragment>
      {modal_open && offerAmount > 0 ? (
        <Fragment>
          <div id="modal-background"></div>
          <animated.div className="CPWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }) =>
              item ? (
                <animated.div className="CPContainer" key={key} style={props}>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Cancel onClick={() => {
                      dispatch(dialogOpen(false))
                    }} />
                  </div>
                  <div className="Container">
                    <TickIcon />
                    <span className="success-text">
                      Coupon applied successfully
                    </span>
                    <span className="offerPrice-text">
                      {restaurantCountry != "US" ? (
                        <> Rs {offerAmount.toFixed(2)}</>
                      ) : (
                        <> ${offerAmount.toFixed(2)}</>
                      )}
                    </span>
                    <span className="secondary-text">
                      You saved with this coupon
                    </span>
                  </div>
                </animated.div>
              ) : null
            )}
          </animated.div>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

export default SurveyPrompt;
